import { Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-[#f5f6fa] flex items-center justify-center p-4">
      <Card className="w-full max-w-[720px] shadow-sm">
        <div className="text-[42px] font-semibold leading-none text-[#1677ff] mb-2">404</div>
        <h1 className="text-[26px] font-semibold mb-2">{t('not_found.title')}</h1>
        <p className="text-[#595959] mb-6">{t('not_found.description')}</p>

        <div className="flex items-center gap-2">
          <Button type="primary" onClick={() => navigate(-1)}>{t('not_found.back')}</Button>
        </div>
      </Card>
    </div>
  );
}
